import useTranslation from 'common/hooks/useTranslation';
import React from 'react';

const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });

const ExperienceSection = ({ experienceEntries, experience }) => {
  const isValidEntries =
    Array.isArray(experienceEntries) && experienceEntries.length > 0;
  const { t } = useTranslation('offers\\details');

  return (
    <section className='w-full flex flex-col gap-2 text-dark-charcoal'>
      <h4 className='text-dark-liver font-semibold uppercase mb-2'>
        {t('experience')}
      </h4>
      {isValidEntries ? (
        experienceEntries.map(
          ({ title, company, start_date, end_date, summary }, index) => (
            <div
              key={index}
              className='border-b border-gray-200 pb-2 last:border-none'
            >
              <div className='flex justify-between text-sm text-sonic-silver font-semibold'>
                <span>
                  {title} at {company}
                </span>
                <span className='text-cool-grey font-normal'>
                  ({formatDate(start_date)} to{' '}
                  {end_date ? formatDate(end_date) : 'Present'})
                </span>
              </div>
              <p className='text-sm mt-2'>{summary}</p>
            </div>
          ),
        )
      ) : (
        <p className='text-sm'>{experience || 'N/A'}</p>
      )}
    </section>
  );
};

export default ExperienceSection;
